import getResponseJson from './getresponsejson';

export const auditReasonResolutionService = serviceRoutes => {
  const resolveAuditReason = (
    encounterAuditReasonId,
    resolutionTypeId,
    isResolved
  ) => {
    return fetch(serviceRoutes.resolveAuditReason, {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        encounterAuditReasonId,
        resolutionTypeId,
        isResolved
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  return {
    resolveAuditReason,
    serviceRoutes
  };
};

export default auditReasonResolutionService;
